import { combineReducers } from '@reduxjs/toolkit';

import agendamentosReducer from './reducers/agendamentos';
import atendimentosReducer from './reducers/atendimentos';
import canaisReducer from './reducers/canais';
import comentariosReducer from './reducers/comentarios';
import contatosReducer from './reducers/contatos';
import equipesReducer from './reducers/equipes';
import funnelsSlice from './reducers/funnels';
import galeriasReducer from './reducers/galerias';
import gruposReducer from './reducers/grupos';
import mensagensReducer from './reducers/mensagens';
import tagsReducer from './reducers/tags';
import templatesReducer from './reducers/templates';
import usuariosReducer from './reducers/usuarios';

const rootReducer = combineReducers({
  agendamentos: agendamentosReducer,
  atendimentos: atendimentosReducer,
  canais: canaisReducer,
  comentarios: comentariosReducer,
  contatos: contatosReducer,
  equipes: equipesReducer,
  galerias: galeriasReducer,
  grupos: gruposReducer,
  mensagens: mensagensReducer,
  tags: tagsReducer,
  usuarios: usuariosReducer,
  templates: templatesReducer,
  funnels: funnelsSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
